/** 为高性能设备添加 SMAA 抗锯齿和跟随相机注视点的景深。 */
import { usePerformanceMonitor } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import {
    EffectComposer,
    DepthOfField,
    SMAA,
} from '@react-three/postprocessing';
import { useRef, useState } from 'react';
import { cameraLookAtVec } from '../../lookAtVec';

type Props = {
    enabled?: boolean;
};

const Postprocessing = ({ enabled = true }: Props) => {
    const dof = useRef<any>();

    // 景深内部缓冲分辨率；更高更清晰，也更耗显存和填充率。
    const [dofHeight, setDofHeight] = useState(1024);

    usePerformanceMonitor({
        // 帧率不足时把景深缓冲减半，是不改变构图的性能降级。
        onChange: ({ fps }) => {
            if (fps > 60) {
                setDofHeight(1024);
            } else {
                setDofHeight(512);
            }
        },
    });

    useFrame(() => {
        // cameraLookAtVec 会被 FlyingCamera 原地更新，因此每帧把它同步给 DOF。
        if (dof.current) {
            dof.current.target = cameraLookAtVec;
        }
    });

    return (
        <EffectComposer
            // 不使用额外多重采样和法线通道，降低后处理成本。
            multisampling={0}
            disableNormalPass={true}
            enabled={enabled}
        >
            <SMAA />
            <DepthOfField
                ref={dof}
                bokehScale={5}
                height={dofHeight}
                target={cameraLookAtVec}
            />
        </EffectComposer>
    );
};

export default Postprocessing;
